import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';
import TopPerformers from '../components/TopPerformers';
import ProductsBrowser from '../components/ProductsBrowser';
// Old TradeTracker hidden - now using SheetViewer for live data
// import TradeTracker from '../components/TradeTracker';
import SheetViewer from '../components/SheetViewer';
import { useTheme } from '../context/ThemeContext';
import './GuruDashboard.css';

function GuruDashboard() {
  const { slug } = useParams();
  const { theme, toggleTheme, isDark } = useTheme();
  // Default to "graham-lindman" if no slug provided (for root path "/")
  const guruSlug = slug || 'graham-lindman';
  const [guru, setGuru] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('dashboard'); // 'dashboard', 'tracker', or 'products'

  useEffect(() => {
    const fetchGuruData = async () => {
      try {
        setLoading(true);
        const guruRes = await api.get(`/gurus/${guruSlug}`);
        setGuru(guruRes.data);
        setLoading(false);
      } catch (err) {
        setError(`Failed to load guru data: ${err.message}`);
        setLoading(false);
      }
    };

    fetchGuruData();
  }, [guruSlug]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!guru) return <div className="error">Guru not found</div>;

  return (
    <div className="guru-dashboard">
      <div className="guru-header-container">
        <button className="theme-toggle-corner" onClick={toggleTheme} aria-label="Toggle theme">
          <span className="toggle-icon">{isDark ? '☀️' : '🌙'}</span>
          <span className="toggle-text">{isDark ? 'Light Mode' : 'Dark Mode'}</span>
        </button>
        <div className="guru-header">
          <div className="guru-info">
            <div className="text-logo">
              <div className="logo-main">
                <span className="logo-alpha">ALPHA</span>
                <span className="logo-edge">EDGE</span>
              </div>
              <span className="logo-subtitle">Trading Grid</span>
            </div>
          </div>
        </div>

        {/* Tab Selector inside header container */}
        <div className="tab-selector">
          <button
            className={`tab-button ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            <span className="tab-icon">📊</span>
            <span className="tab-label">Dashboard</span>
          </button>
          <button
            className={`tab-button ${activeTab === 'tracker' ? 'active' : ''}`}
            onClick={() => setActiveTab('tracker')}
          >
            <span className="tab-icon">📈</span>
            <span className="tab-label">Trade Tracker</span>
          </button>
          <button
            className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
            onClick={() => setActiveTab('products')}
          >
            <span className="tab-icon">🎯</span>
            <span className="tab-label">All Products</span>
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'dashboard' && (
          <div className="rankings-section">
            <TopPerformers guruSlug={guruSlug} />
          </div>
        )}

        {activeTab === 'tracker' && (
          <div className="tracker-section">
            <SheetViewer guruSlug={guruSlug} />
          </div>
        )}

        {activeTab === 'products' && (
          <ProductsBrowser guruSlug={guruSlug} />
        )}
      </div>
    </div>
  );
}

export default GuruDashboard;
